<template>
  <div class="onboarding-done">
    <EnteteOnboardingMinerve
      etape="Terminé"
      titre="Tout est prêt"
      :texte="texte"
      :mouvements="['nod', 'blink']"
    />
    <Button v-focus @click="router.push('/')">Accéder à Follaw</Button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import Button from "@follaw-fr/components/reusable/atoms/Button.vue";
import EnteteOnboardingMinerve from "@follaw-fr/components/onboarding/molecules/EnteteOnboardingMinerve.vue";

const router = useRouter();

// Le texte ne raconte que ce que l'étape précédente a réellement créé (cases cochées et appels réussis,
// transmis par l'état de navigation). Arrivée directe : aucune affirmation sur ce qui existe.
type Bilan = {
  followFeuilleVerte?: boolean;
  digestJorf?: boolean;
  alertTranscription?: boolean;
};
const bilan = (router.options.history.state?.bilan ?? null) as Bilan | null;

const creations = [
  bilan?.digestJorf && "le récapitulatif du Journal officiel",
  bilan?.followFeuilleVerte &&
    "le suivi de la feuille verte et des ordres du jour",
  bilan?.alertTranscription && "l'alerte sur les directs vidéo",
].filter(Boolean) as string[];

const texte = !bilan
  ? "Retrouvez vos veilles dans Follaw."
  : creations.length
    ? `Votre veille est en place, avec ${creations.join(", ")}. Minerve veille à votre place.`
    : "Votre veille est en place. Minerve veille à votre place.";
</script>

<style scoped lang="scss">
.onboarding-done {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 40px 24px;
}
</style>
